export default [
  {
    title: 'Women Popular Categories',
    links: [
      {
        href: '/women/indianwear/blouse/c/164',
        text: 'Designer Blouse',
      },
      {
        href: '/women/indianwear/sarees/c/10',
        text: 'Sarees',
      },
      {
        href: '/women/indianwear/dupattas/c/647',
        text: 'Dupattas',
      },
      {
        href: '/women/indianwear/palazzos/c/156',
        text: 'Palazzos',
      },
      {
        href: '/women/westernwear/dresses/c/5',
        text: 'Dresses',
      },
      {
        href: '/women/westernwear/shirts-tops-and-crop-tops/c/4497',
        text: 'Tops',
      },
      {
        href: '/women/westernwear/bottoms-pants-and-trousers/c/7',
        text: 'Pants',
      },
      {
        href: '/women/westernwear/jackets-and-coats/c/5262',
        text: 'Women Jackets',
      },
      {
        href: '/women/westernwear/skirts/c/159',
        text: 'Skirts',
      },
      {
        href: '/women/westernwear/sweatshirts/c/66',
        text: 'Women Sweatshirts',
      },
      {
        href: '/women/westernwear/gowns/c/153',
        text: 'Gowns',
      },
      {
        href: '/women/accessories/hair-accessories/c/5187',
        text: 'Hair Accessories',
      },
      {
        href: '/women/accessories/eyewear/women-sunglasses/c/4640',
        text: 'Women Sunglasses',
      },
      {
        href: '/women/lingerie/bra/c/3947',
        text: 'Bra',
      },
      {
        href: '/women/lingerie/underwear/bikini/c/3977',
        text: 'Bikini',
      },
      {
        href: '/women/bags/sling-and-cross-bags/c/91',
        text: 'Sling Bags',
      },
      {
        href: '/women/jewellery/pendants/c/3971',
        text: 'Pendants',
      },
      {
        href: '/women/lingerie/swimwear/c/4011',
        text: 'Women Swimwear',
      },
      {
        href: '/women/bags/handbags/c/669',
        text: 'Handbags',
      },
      {
        href: '/women/maternity-wear/c/8214',
        text: 'Maternity Wear',
      },
    ],
  },
  {
    title: "Men's Popular Categories",
    links: [
      {
        href: '/men/topwear/t-shirts/c/6825',
        text: 'Men T Shirts',
      },
      {
        href: '/men/topwear/casual-shirts/c/6826',
        text: 'Mens Shirts',
      },
      {
        href: '/men/topwear/polo-t-shirts/c/6827',
        text: 'Polo T Shirts',
      },
      {
        href: '/men/topwear/formal-shirts/c/6828',
        text: 'Formal Shirts',
      },
      {
        href: '/men/topwear/jackets/c/6829',
        text: 'Mens Jackets',
      },
      {
        href: '/men/topwear/hoodies/c/6831',
        text: 'Hoodies',
      },
      {
        href: '/men/ethnicwear/nehru-jackets/c/6848',
        text: 'Nehru Jackets',
      },
      {
        href: '/men/bottoms/trackpants/c/6839',
        text: 'Trackpants',
      },
      {
        href: '/men/bottoms/chinos/c/6838',
        text: 'Chinos',
      },
      {
        href: '/men/bottoms/jeans/c/6835',
        text: 'Mens Jeans',
      },
      {
        href: '/men/bottoms/formal-trousers/c/6837',
        text: 'Formal Trousers',
      },
      {
        href: '/men/topwear/suits/c/7006',
        text: 'Mens Suits',
      },
      {
        href: '/men/ethnicwear/kurta-sets/c/6844',
        text: 'Mens Kurta Sets',
      },
      {
        href: '/men/personal-accessories/sunglasses/c/6880',
        text: 'Sunglasses',
      },
      {
        href: '/men/personal-accessories/wallets/c/6881',
        text: 'Wallets',
      },
      {
        href: '/men/personal-accessories/belts/c/6882',
        text: 'Belts',
      },
      {
        href: '/men/sports-and-athleisure/jerseys/c/6890',
        text: 'Jerseys',
      },
      {
        href: '/men/bottoms/joggers/c/7892',
        text: 'Joggers for Men',
      },
    ],
  },
  {
    title: 'Kids Popular Categories',
    links: [
      {
        href: '/kids/winterwear/c/6320',
        text: 'Kids Winterwear',
      },
      {
        href: '/kids/personal-care/c/9311',
        text: 'Kids Personal Care',
      },
      {
        href: '/kids/infant-accessories/c/6358',
        text: 'Infant Accessories',
      },
    ],
  },
  {
    title: 'Popular Footwear Categories',
    links: [
      {
        href: '/men/footwear/c/6857',
        text: 'Shoes',
      },
      {
        href: '/women/footwear/heels/c/3523',
        text: 'Heels',
      },
      {
        href: '/women/footwear/flats/c/3521',
        text: 'Flats',
      },
      {
        href: '/women/footwear/boots/c/3530',
        text: 'Women Boots',
      },
      {
        href: '/women/footwear/mules/c/3916',
        text: 'Mules',
      },
      {
        href: '/women/footwear/wedges/c/3529',
        text: 'Wedges',
      },
      {
        href: '/men/footwear/ethnic-footwear/c/11193',
        text: 'Ethnic Shoes for Men',
      },
      {
        href: '/formal-footwear/c/4267',
        text: 'Formal Shoes',
      },
      {
        href: '/men/ethnicwear/kurta-sets/c/6844',
        text: "Men's Boots",
      },
      {
        href: '/men/footwear/flipflops-sliders/c/6861',
        text: 'Flip Flops',
      },
      {
        href: '/women/footwear/loafers/c/3533',
        text: 'Loafers',
      },
      {
        href: '/women/footwear/sport-shoes/c/3928',
        text: 'Sneakers',
      },
      {
        href: '/women/footwear/juttis/c/3532',
        text: 'Juttis',
      },
    ],
  },
  {
    title: 'Sports And Fitness Equipment',
    links: [
      {
        href: '/sports-fitness-equipment/team-sports/cricket/c/11221',
        text: 'Cricket',
      },
      {
        href: '/sports-fitness-equipment/team-sports/football/c/11314',
        text: 'Football',
      },
      {
        href: '/sports-fitness-equipment/team-sports/volleyball/c/11319',
        text: 'Vollyball',
      },
      {
        href: '/sports-fitness-equipment/team-sports/basketball/c/11332',
        text: 'Basketball',
      },
      {
        href: '/sports-fitness-equipment/racket-sports/badminton/c/11418',
        text: 'Badminton',
      },
      {
        href: '/sports-fitness-equipment/racket-sports/tennis/c/118300',
        text: 'Tennis',
      },
      {
        href: '/sports-fitness-equipment/cardio-equipments/c/11542',
        text: 'Cardio Equipments',
      },
      {
        href: '/sports-fitness-equipment/strength-training/c/11543',
        text: 'Strength Training',
      },
      {
        href: '/sports-fitness-equipment/fitness-accessories/c/11544',
        text: 'Fitness Accessories',
      },
    ],
  },
  {
    title: 'Home',
    links: [
      {
        href: '/bedding/c/8529',
        text: 'Bedding',
      },
      {
        href: '/home/bath/c/8559',
        text: 'Bath',
      },
      {
        href: '/home/decor/c/8594',
        text: 'Decor',
      },
      {
        href: '/lighting/c/8631',
        text: 'Lighting',
      },
      {
        href: '/home/kitchen-dining/c/8707',
        text: 'Kitchen',
      },
      {
        href: '/storage/c/8831',
        text: 'Storage',
      },
      {
        href: '/home/decor/wall-decor/clocks/c/8597',
        text: 'Clocks',
      },
      {
        href: '/home/decor/photo-frames/c/8611',
        text: 'Photo Frames',
      },
      {
        href: '/home/home-essentials/c/8853',
        text: 'Home Essentials',
      },
    ],
  },
  {
    title: 'Gadgets And Tech Accessories',
    links: [
      {
        href: '/gadgets-tech-accessories/cases-and-covers/c/6402',
        text: 'Cases and Covers',
      },
      {
        href: '/gadgets-tech-accessories/headphones/c/6395',
        text: 'Headphones',
      },
      {
        href: '/gadgets-tech-accessories/speakers/c/6396',
        text: 'Speakers',
      },
      {
        href: '/gadgets-tech-accessories/power-banks/c/6404',
        text: 'Power Banks',
      },
      {
        href: '/gadgets-tech-accessories/smart-watches-and-activity-trackers/c/6397',
        text: 'Smart Watches',
      },
      {
        href: '/gadgets-tech-accessories/computer-peripherals/c/7674',
        text: 'Computer Peripherals',
      },
      {
        href: '/gadgets-tech-accessories/smart-home-devices/c/7677',
        text: 'Smart Home Devices',
      },
      {
        href: '/gadgets-tech-accessories/cameras-and-accessories/c/7679',
        text: 'Cameras And Accessories',
      },
    ],
  },
  {
    title: 'Other Popular Brands',
    links: [
      {
        href: '/designers/indya/c/4060',
        text: 'Indya',
      },
      {
        href: '/designers/biba/c/5274',
        text: 'Biba',
      },
      {
        href: '/designers/rare-rabbit/c/7140',
        text: 'Rare Rabbit',
      },
      {
        href: '/designers/reebok/c/7199',
        text: 'Reebok',
      },
      {
        href: '/designers/aurelia/c/4036',
        text: 'Aurelia',
      },
      {
        href: '/designers/zivame/c/4107',
        text: 'Zivame',
      },
      {
        href: '/designers/the-kaftan-company/c/3514',
        text: 'The Kaftan Company',
      },
      {
        href: '/designers/bunaai/c/5278',
        text: 'Bunaai',
      },
      {
        href: '/designers/soch/c/7657',
        text: 'Soch',
      },
      {
        href: '/designers/vero-moda/c/4188',
        text: 'Vero Moda',
      },
      {
        href: '/designers/raymond/c/7204',
        text: 'Raymond',
      },
      {
        href: '/designers/crocs/c/6497',
        text: 'Crocs',
      },
      {
        href: '/designers/forever-new/c/4495',
        text: 'Forever New',
      },
      {
        href: '/designers/metro/c/4383',
        text: 'Metro',
      },
      {
        href: '/designers/titan/c/6947',
        text: 'Titan',
      },
      {
        href: '/designers/fossil/c/5217',
        text: 'Fossil',
      },
      {
        href: '/designers/lakshita/c/4287',
        text: 'Lakshita',
      },
      {
        href: '/designers/ritu-kumar/c/1961',
        text: 'Ritu Kumar',
      },
      {
        href: '/designers/bugatti/c/7366',
        text: 'Bugatti',
      },
      {
        href: '/designers/manyavar/c/8280',
        text: 'Manyavar',
      },
      {
        href: '/designers/lavanya-the-label/c/5141',
        text: 'Lavanya the Label',
      },
      {
        href: '/designers/zaveri-pearls/c/4876',
        text: 'Zaveri Pearls',
      },
    ],
  },
  {
    title: 'Poplular Searches',
    links: [
      {
        href: '/designers/heart-up-my-sleeves/c/11225',
        text: 'Heart Up My Sleeve',
      },
      {
        href: '/women/jewellery/earrings/c/78',
        text: 'Earrings',
      },
      {
        href: '/sharara-sets/c/5885',
        text: 'Sharara Suits',
      },
      {
        href: '/global-desi-gold-stripes-top-1/p/250926',
        text: 'Desi Gold',
      },
      {
        href: '/global-desi-blue-printed-kurta/p/92963',
        text: 'Desi Blue',
      },
      {
        href: '/anarkali-kurtas-suit/c/4686',
        text: 'Anarkali Suits',
      },
      {
        href: '/women/indianwear/lehengas/c/652',
        text: 'Lehenga For Women',
      },
      {
        href: '/silk-sarees/c/4798',
        text: 'Silk Saree',
      },
      {
        href: '/authentic-chikankari/c/5882',
        text: 'Chikankari Kurti',
      },
      {
        href: '/ahalyaa-brown-pleated-ready-to-wear-saree-with-stitched-blouse-set-of-2/p/369972',
        text: 'Ready To Wear Saree',
      },
      {
        href: '/party-wear-sarees/c/4785',
        text: 'Party Wear Saree',
      },
      {
        href: '/women/westernwear/sets/c/4542',
        text: 'Co Ord Sets Women',
      },
      {
        href: '/couple-watch-sets/c/6793',
        text: 'Couple Watches',
      },
      {
        href: '/women/jewellery/jewellery-sets/c/4540',
        text: 'Jewellery Sets',
      },
      {
        href: '/evil-eye-edit/c/6901',
        text: 'Evil Eye Pendant',
      },
      {
        href: '/boat-neck-suit-sets/c/6656',
        text: 'Suit Neck Design',
      },
      {
        href: '/designers/titan/c/6947',
        text: 'Titan Watches For Women',
      },
      {
        href: '/women/indianwear/salwar-suits-and-sets/c/69',
        text: 'Suits For Women',
      },
      {
        href: '/lacha/c/9915',
        text: 'Lacha',
      },
      {
        href: '/faballey-pink-buckled-waist-jumpsuit/p/274963',
        text: 'Jumpsuit',
      },
      {
        href: '/bodycon-dresses/c/5654',
        text: 'Bodycon Dress',
      },
      {
        href: '/men/personal-accessories/caps-and-hats/c/6885',
        text: 'Cap',
      },
      {
        href: '/dp/men-hoodies',
        text: 'Men Hoodies',
      },
      {
        href: '/dp/diamond-rings',
        text: 'Diamond Rings',
      },
      {
        href: '/dp/gold-mangalsutra',
        text: 'Gold Mangalsutra',
      },
      {
        href: '/dp/gold-bangle',
        text: 'Gold Bangle',
      },
      {
        href: '/dp/men-gold-rings',
        text: 'Men Gold Rings',
      },
      {
        href: '/dp/chikankari-kurtis',
        text: 'Chikankari Kurtis',
      },
      {
        href: '/dp/women-jackets',
        text: 'Women Jackets',
      },
      {
        href: '/dp/men-silver-bracelet',
        text: 'Men Silver Bracelet',
      },
      {
        href: '/dp/men-gold-bracelet',
        text: 'Men Gold Bracelet',
      },
      {
        href: '/dp/women-gold-rings',
        text: 'Women Gold Rings',
      },
      {
        href: '/dp/wedding-lehengas',
        text: 'Wedding Lehengas',
      },
      {
        href: '/dp/men-winter-jackets',
        text: 'Men Winter Jackets',
      },
      {
        href: '/dp/men-sweatshirts',
        text: 'Men Sweatshirts',
      },
      {
        href: '/dp/women-sweatshirts',
        text: 'Women Sweatshirts',
      },
      {
        href: '/dp/men-wedding-suits',
        text: 'Men Wedding Suits',
      },
      {
        href: '/dp/women-gold-bracelet',
        text: 'Women Gold Bracelet',
      },
      {
        href: '/dp/men-silver-rings',
        text: 'Men Silver Rings',
      },
      {
        href: '/dp/traditional-dresses',
        text: 'Traditional Dresses',
      },
      {
        href: '/dp/kaftan-dresses',
        text: 'Kaftan Dresses',
      },
      {
        href: '/dp/men-sweaters',
        text: 'Men Sweaters',
      },
      {
        href: '/dp/men-leather-jackets',
        text: 'Men Leather Jackets',
      },
      {
        href: '/dp/men-tracksuits',
        text: 'Men Tracksuits',
      },
      {
        href: '/dp/women-wedding-dresses',
        text: 'Women Wedding Dresses',
      },
      {
        href: '/dp/men-sherwanis',
        text: 'Men Sherwanis',
      },
      {
        href: '/dp/diamond-necklace',
        text: 'Diamond Necklace',
      },
      {
        href: '/dp/g-shock-watches',
        text: 'G Shock Watches',
      },
      {
        href: '/dp/co-ord-set',
        text: 'Co Ord Set',
      },
      {
        href: '/dp/women-skirts',
        text: 'Women Skirts',
      },
      {
        href: '/dp/women-gold-earrings',
        text: 'Women Gold Earrings',
      },
      {
        href: '/dp/tank-top',
        text: 'Tank Top',
      },
      {
        href: '/dp/girls-hoodies',
        text: 'Girls Hoodies',
      },
      {
        href: '/dp/platinum-rings',
        text: 'Platinum Rings',
      },
      {
        href: '/dp/churidars',
        text: 'Churidars',
      },
      {
        href: '/dp/banarasi-silk-sarees',
        text: 'Banarasi Silk Sarees',
      },
      {
        href: '/dp/women-earrings',
        text: 'Women Earrings',
      },
      {
        href: '/dp/patterned-blouse',
        text: 'Patterned Blouse',
      },
      {
        href: '/dp/boys-shirts',
        text: 'Boys Shirts',
      },
      {
        href: '/dp/diamond-earrings',
        text: 'Diamond Earrings',
      },
      {
        href: '/dp/puff-sleeves-blouse',
        text: 'Puff Sleeves Blouse',
      },
      {
        href: '/dp/gold-nose-rings',
        text: 'Gold Nose Rings',
      },
    ],
  },
  {
    title: 'Shop By Trends',
    links: [
      {
        href: '/spring-summer-22/c/12077',
        text: 'Summer Cloths',
      },
      {
        href: '/cotton-tops/c/9356',
        text: 'Cotton Tops',
      },
      {
        href: '/cotton-shorts-women/c/9348',
        text: 'Cotton Shorts',
      },
      {
        href: '/cotton-t-shirt-men/c/10741',
        text: 'Cotton T Shirts for Men',
      },
    ],
  },
];
